import React from "react";
import CategorySelect from "../../../../../assets/components/CategorySelect";

export default function Step2({ data = {}, update, categoryState }) {
    const baseInputStyle = {
        color: "var(--ink-default,#1F2937)",
        borderBottom: "1px solid var(--coolgrey-200,#E3E7EF)",
    };

    return (
        <div className="flex flex-col gap-8">
            {/* 가게 이름 */}
            <Field label="가게 이름">
                <input
                    className="w-full bg-transparent outline-none py-2 placeholder:opacity-60"
                    style={baseInputStyle}
                    placeholder="운영중인 가게 이름"
                    value={data.storeName ?? ""}
                    onChange={(e) => update({ storeName: e.target.value })}
                />
            </Field>

            {/* 가게 주소 */}
            <Field label="가게 주소">
                <div className="flex items-center gap-2">
                    <input
                        className="flex-1 bg-transparent outline-none py-2 placeholder:opacity-60 cursor-pointer"
                        style={baseInputStyle}
                        placeholder="도로명 주소"
                        value={data.roadAddress ?? ""}
                        readOnly                              // 직접 타이핑 불가
                        onClick={data.onSearchAddress}        // 인풋 클릭 시 주소 검색 실행
                    />
                    <button
                        type="button"
                        className="h-9 px-3 rounded-md border text-black"
                        onClick={data.onSearchAddress}
                    >
                        주소 검색
                    </button>
                </div>
            </Field>


            {/* 상세 주소 */}
            <Field label="상세 주소">
                <input
                    className="w-full bg-transparent outline-none py-2 placeholder:opacity-60"
                    style={baseInputStyle}
                    placeholder="상세 주소를 입력해 주세요"
                    value={data.addressDetail ?? ""}
                    onChange={(e) => update({ addressDetail: e.target.value })}
                />
            </Field>

            {/* 업종 (그대로 전달) */}
            <div className="w-full flex gap-4 pb-4 text-black">
                <CategorySelect {...categoryState} />
            </div>


        </div>
    );
}

function Field({ label, children }) {
    return (
        <div>
            <p className="mb-2 text-sm font-semibold" style={{ color: "var(--ink-strong,#101828)" }}>
                {label}
            </p>
            {children}
        </div>
    );
}
